import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { SHIPPINGS } from '../constants'

import { Shipping } from '../types'
import { Meta } from '@/features/filters/types'

type ShippingsResponse = {
  data: Shipping[]
  meta: Meta
}

const getShippings = async (params: Meta): Promise<ShippingsResponse> => {
  const response = await fetchAPI({
    path: `/shippings`,
    params,
  })

  const data = get(response, 'data.shippings', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useShippings = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: ShippingsResponse
}) => {
  return useQuery<ShippingsResponse, AxiosError>({
    queryKey: [SHIPPINGS, params],
    queryFn: () => getShippings(params),
    keepPreviousData: true,
    initialData,
  })
}
